module.exports = __webpack_public_path__ + "img/erecruiter.a9df211a.png";